import React, { useRef, useEffect, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import * as Ui from './styles';

// medias
const w360Media = '(max-width: 360px)';
const w720Media = '(max-width: 720px)';
const w1440Media = '(max-width: 1440px)';
// alias
const WIDE_SCREENS = ['w360', 'w720', 'w1440'];

const propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  srcSet: PropTypes.array,
  className: PropTypes.string,
};

const defaultProps = {
  srcSet: [],
};

/**
 * RImage possui função de modificar a imagem de acordo com a resolução da tela.
 * Para isto é necessário informar qual a url e a dimensão mínima, sendo possível:
 * - screen: w360
 * - screen: w720
 * - screen: w1440 (default)
 *
 * @param srcSet um array no formato [{src: string, screen: string}]
 * @param className nome de uma classe de estilo
 * @param alt from DOM
 * @param src from DOM
 */
export function RImage(props) {
  // props from parent
  const { srcSet, className } = props;
  // props from DOM
  const { alt, src } = props;
  // refs
  const localRef = useRef();
  // state
  const [wSrc, setWSrc] = useState(null);

  const doResolveResolution = useCallback((resolution) => {
    // default
    if (!resolution) {
      setWSrc(src);
      return false;
    }
    // seleciona uma resolução dentro do conjunto, se houver
    let s = null;
    srcSet.forEach((sItem) => {
      if (sItem.screen === resolution) {
        s = sItem.src;
      }
    });
    // atualiza o estado
    setWSrc(s || src);
    // retorna verdadeiro se encontrou uma tela
    return !!s;
  }, [srcSet, src]);

  // callback: resolve resolution and update wsrc state

  // TODO O objetivo deste treco de código é rerenderizar este componente quando o atributo srcSet for mudado pelo component Logo, verificar se é a melhor forma e fazer isto
  React.useEffect(() => {
    doResolveResolution();
  }, [srcSet, doResolveResolution]);

  // callback: a listener for change media query
  const resolveMediaQuery = useCallback((mediaQuery) => {
    if (mediaQuery.matches && mediaQuery.media === w360Media) {
      return doResolveResolution(WIDE_SCREENS[0]);
    } if (mediaQuery.matches && mediaQuery.media === w720Media) {
      return doResolveResolution(WIDE_SCREENS[1]);
    } if (mediaQuery.matches && mediaQuery.media === w1440Media) {
      return doResolveResolution(WIDE_SCREENS[2]);
    }
    return doResolveResolution(null);
  }, [doResolveResolution]);

  // efeito inicial para registro do listener
  useEffect(() => {
    // choises
    const w360 = window.matchMedia(w360Media);
    const w720 = window.matchMedia(w720Media);
    const w1440 = window.matchMedia(w1440Media);
    // first time
    if (!resolveMediaQuery(w360)) {
      if (!resolveMediaQuery(w720)) {
        resolveMediaQuery(w1440);
      }
    }
    // add listeners
    w360.addListener(resolveMediaQuery);
    w720.addListener(resolveMediaQuery);
    w1440.addListener(resolveMediaQuery);
    // remove listeners
    return () => {
      w360.removeListener(resolveMediaQuery);
      w720.removeListener(resolveMediaQuery);
      w1440.removeListener(resolveMediaQuery);
    };
  }, [localRef, resolveMediaQuery]);

  return (
    <Ui.Image
      alt={alt}
      ref={localRef}
      className={className}
      src={wSrc}
    />
  );
}

RImage.propTypes = propTypes;
RImage.defaultProps = defaultProps;
